import React from 'react';
import styles from './AlignContent.module.scss';
import clsx from 'clsx';

export interface AlignContentProps
    extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    /**
     * Horizontal align content
     */
    alignment?: 'left' | 'center' | 'right';

    /**
     * vertical align content
     */
    position?: 'top' | 'center' | 'bottom';
    maxWidth?: string;
}

export const AlignContent = ({
    className,
    position,
    alignment,
    style,
    children,
    maxWidth,
    ...rest
}: AlignContentProps) => {
    return (
        <div
            className={clsx(
                styles.component,
                {
                    [styles[alignment ?? '']]: !!alignment,
                    [styles['p' + (position ?? '')]]: !!position,
                },
                className,
            )}
            style={{ ...style, '--maxWidth': maxWidth || 'none' } as React.CSSProperties}
            {...rest}
        >
            <div className={styles.content}>{children}</div>
        </div>
    );
};
